<language-selection></language-selection>

<div class="outer" *ngIf="showSplash" [class.hide]="hide" (click)="continue()">
  <div class="inner splashscreen-bg" [class.grayscale]="grayscale"
       style.backgroundImage="url('{{baseUrl}}/images/splashscreen')">
    <div class="continue">
      <ng-container *ngIf="loaded$ | async as loaded">
        <a *ngIf="loaded.showContinue">{{'splash-screen.instructions' | translate }}</a>
      </ng-container>
    </div>
  </div>
  <div class="offscreen">
    <img src="{{baseUrl}}/images/logo" />
  </div>
</div>